export default __webpack_public_path__ + "static/media/Greatsword of the Faceless Chaos.fb1b7fb1.jpg";